import React, { useEffect } from 'react'

export const LanguageContext = React.createContext()
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = React.useState('en')

  useEffect(() => {
    if (typeof window === 'undefined') return

    const savedLanguage = localStorage.getItem('preferredLanguage')
    if (savedLanguage) {
      setLanguage(savedLanguage)
      return
    }

    const detectUserCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/')
        const data = await response.json()

        const lang = data.country_code === 'UA' ? 'uk' : 'en'
        setLanguage(lang)
        localStorage.setItem('preferredLanguage', lang)
      } catch (error) {
        console.error('Failed to detect user location:', error)
        setLanguage('en')
        localStorage.setItem('preferredLanguage', 'en')
      }
    }

    detectUserCountry()
  }, [])

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}
